/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export type NzSpaceDirection = 'vertical' | 'horizontal';
export type NzSpaceAlign = 'start' | 'end' | 'center' | 'baseline';
export type NzSpaceSize = 'small' | 'middle' | 'large';
